import React from 'react';
import { styled } from '@mui/material';

import { ResourceChip, Stack, Text } from 'shell/components';
import { TYPES } from 'utils/constants';
import { downloadFileFromURL, getS3FileURL, getTooltipComponent } from 'utils/helper';

const getItemList = (file, currentAccountId) => {
    const isOwner = file.owner_account_id === currentAccountId;
    return [{ key: 'download', value: 'Download' }, ...(isOwner ? [{ key: 'delete', value: 'Delete' }] : [])];
};

const AttachmentsSection = ({ disabled, taskId, fileList, currentAccountId, deleteFile, countFiles }) => {
    const handleSelect = ({ key }, file) => {
        switch (key) {
            case 'download': {
                return downloadFileFromURL(getS3FileURL(file.data), file.data.name);
            }
            case 'delete': {
                return deleteFile(file.id);
            }
        }
    };

    return (
        <CustomStack disabled={disabled} spacing={2}>
            <Stack sx={{ width: 'fit-content' }}>
                <Text
                    aria-disabled={disabled}
                    tooltip={{
                        component: getTooltipComponent('Attachments', 'This is where attached resources will appear'),
                    }}
                    variant={'p2'}
                    weight={'semibold'}
                >
                    Attachments ({countFiles(taskId)})
                </Text>
            </Stack>
            <Stack sx={{ flexFlow: 'wrap' }} spacing={2}>
                {Object.values(fileList)
                    .filter((file) => file.active)
                    .filter((file) => file.type === TYPES.FEEDBACK)
                    .map((file) => (
                        <ResourceChip
                            key={file.id}
                            options={getItemList(file, currentAccountId)}
                            resource={file}
                            size={'small'}
                            type={'file'}
                            onSelect={(option) => handleSelect(option, file)}
                        />
                    ))}
            </Stack>
        </CustomStack>
    );
};

const CustomStack = styled(Stack)(({ disabled }) => {
    return {
        ...(disabled && {
            opacity: 0.5,
        }),
    };
});

export default AttachmentsSection;
